export default defineNuxtRouteMiddleware((to) => {
  // Middleware для управления cookies в зависимости от маршрута
  if (process.client) {
    // Настройка cookies для разных страниц
    const setCookieSettings = () => {
      // Основные настройки для всех страниц
      document.cookie = 'cookieConsent=true; SameSite=None; Secure; Max-Age=31536000; Path=/'
      
      // Настройки для аналитики
      if (to.path.includes('/proxy') || to.path === '/') {
        // На главной и страницах прокси разрешаем аналитику
        document.cookie = 'analyticsConsent=true; SameSite=None; Secure; Max-Age=31536000; Path=/'
      } else {
        // На других страницах ограничиваем
        document.cookie = 'analyticsConsent=false; SameSite=None; Secure; Max-Age=31536000; Path=/'
      }
      
      // Настройки для чата поддержки
      if (to.path.includes('/faq') || to.path.includes('/partners')) {
        document.cookie = 'chatConsent=true; SameSite=None; Secure; Max-Age=31536000; Path=/'
      }
    }
    
    setCookieSettings()
  }
})
